import type { AlertRecord, Invoice } from '../types/alert'
import { daysFromNow, hoursFromNow, minutesFromNow } from '../utils/datetime'

export const alertHistory: AlertRecord[] = [
  {
    id: 'a1',
    type: 'site_down',
    monitorId: 'm3',
    domain: 'api.acme.com',
    sentAt: minutesFromNow(-49),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: '3 consecutive failed checks — HTTP 500 on /v1/health',
  },
  {
    id: 'a2',
    type: 'expiry_warning',
    monitorId: 'm2',
    domain: 'shop.acme.com',
    sentAt: hoursFromNow(-7),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: 'Certificate expires in 9 days — 7-day reminder threshold',
  },
  {
    id: 'a3',
    type: 'expiry_warning',
    monitorId: 'm2',
    domain: 'shop.acme.com',
    sentAt: daysFromNow(-2, 8),
    recipients: ['priya@acme.com', 'ops@acme.com', 'finance@acme.com'],
    delivery: 'failed',
    detail: 'Certificate expires in 11 days — 14-day reminder threshold',
    failureReason: 'finance@acme.com has not confirmed their address yet',
  },
  {
    id: 'a4',
    type: 'site_recovered',
    monitorId: 'm2',
    domain: 'shop.acme.com',
    sentAt: daysFromNow(-4, 22),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: 'Back up after 14 minutes — HTTP 200 in 241ms',
  },
  {
    id: 'a5',
    type: 'site_down',
    monitorId: 'm2',
    domain: 'shop.acme.com',
    sentAt: daysFromNow(-4, 22),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: '2 consecutive failed checks — HTTP 503',
  },
  {
    id: 'a6',
    type: 'certificate_renewed',
    monitorId: 'm4',
    domain: 'blog.acme.com',
    sentAt: daysFromNow(-3, 8),
    recipients: ['priya@acme.com'],
    delivery: 'delivered',
    detail: 'New certificate from Google Trust Services WE1, valid 90 days',
  },
  {
    id: 'a7',
    type: 'site_recovered',
    monitorId: 'm5',
    domain: 'status.acme.com',
    sentAt: hoursFromNow(-8),
    recipients: ['ops@acme.com'],
    delivery: 'delivered',
    detail: 'Back up after 16 minutes — HTTP 200 in 318ms',
  },
  {
    id: 'a8',
    type: 'site_down',
    monitorId: 'm5',
    domain: 'status.acme.com',
    sentAt: hoursFromNow(-9),
    recipients: ['ops@acme.com'],
    delivery: 'delivered',
    detail: '2 consecutive failed checks — HTTP 429 from CDN edge',
  },
  {
    id: 'a9',
    type: 'certificate_renewed',
    monitorId: 'm3',
    domain: 'api.acme.com',
    sentAt: daysFromNow(-14, 8),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: "New certificate from Let's Encrypt R11, valid 90 days",
  },
  {
    id: 'a10',
    type: 'expiry_warning',
    monitorId: 'm1',
    domain: 'acme.com',
    sentAt: daysFromNow(-29, 8),
    recipients: ['priya@acme.com', 'ops@acme.com'],
    delivery: 'delivered',
    detail: 'Certificate expires in 3 days — 3-day reminder threshold',
  },
]

export const invoices: Invoice[] = [
  {
    id: 'inv1',
    number: 'WT-2041',
    issuedAt: daysFromNow(-4),
    amount: 15,
    planName: 'Pro',
    periodLabel: 'Monthly',
    status: 'paid',
  },
  {
    id: 'inv2',
    number: 'WT-1988',
    issuedAt: daysFromNow(-34),
    amount: 15,
    planName: 'Pro',
    periodLabel: 'Monthly',
    status: 'paid',
  },
  {
    id: 'inv3',
    number: 'WT-1930',
    issuedAt: daysFromNow(-64),
    amount: 15,
    planName: 'Pro',
    periodLabel: 'Monthly',
    status: 'paid',
  },
  {
    id: 'inv4',
    number: 'WT-1871',
    issuedAt: daysFromNow(-94),
    amount: 5,
    planName: 'Standard',
    periodLabel: 'Monthly',
    status: 'paid',
  },
  {
    id: 'inv5',
    number: 'WT-1815',
    issuedAt: daysFromNow(-124),
    amount: 5,
    planName: 'Standard',
    periodLabel: 'Monthly',
    status: 'paid',
  },
]

export const countries: string[] = [
  'United States',
  'United Kingdom',
  'India',
  'Germany',
  'Australia',
  'Canada',
  'Singapore',
  'Netherlands',
]

export const timezones: string[] = [
  'Asia/Kolkata',
  'Europe/London',
  'Europe/Berlin',
  'America/New_York',
  'America/Los_Angeles',
  'Australia/Sydney',
  'UTC',
]
